<template>
    <div
        class="c-spinner"
        :class="{ 'c-spinner--disabled': disabled, 'c-spinner--large': large }"
    >
        <span
            @click="decreaseNumber()"
            class="c-spinner__button c-spinner__button--down"
        >
            <svg
                v-if="showDelete"
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="trash"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
            >
                <path
                    fill="currentColor"
                    d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
                    class=""
                ></path>
            </svg>

            <svg
                v-if="!showDelete"
                width="12px"
                height="2px"
                viewBox="0 0 12 2"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
            >
                <g
                    id="Desktop"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                >
                    <g
                        id="SlideinBasket"
                        transform="translate(-1201.000000, -312.000000)"
                        fill="#666666"
                        fill-rule="nonzero"
                    >
                        <g
                            id="Minus"
                            transform="translate(1201.000000, 312.000000)"
                        >
                            <rect
                                id="Rectangle"
                                x="0"
                                y="0"
                                width="12"
                                height="2"
                                rx="1"
                            ></rect>
                        </g>
                    </g>
                </g>
            </svg>
        </span>

        <input
            type="text"
            :value="numericValue"
            @keypress="validateInput"
            @input="inputValue"
            :min="min"
            class="c-spinner__input"
        />

        <span
            @click="increaseNumber()"
            class="c-spinner__button c-spinner__button--up"
        >
            <svg
                width="12px"
                height="12px"
                viewBox="0 0 12 12"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
            >
                <g
                    id="Desktop"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                >
                    <g
                        id="SlideinBasket"
                        transform="translate(-1301.000000, -307.000000)"
                        fill="#666666"
                        fill-rule="nonzero"
                    >
                        <g
                            id="Plus"
                            transform="translate(1301.000000, 307.000000)"
                        >
                            <path
                                d="M6,0 C6.55228475,-1.01453063e-16 7,0.44771525 7,1 L7,5 L11,5 C11.5522847,5 12,5.44771525 12,6 C12,6.55228475 11.5522847,7 11,7 L7,7 L7,11 C7,11.5522847 6.55228475,12 6,12 C5.44771525,12 5,11.5522847 5,11 L5,7 L1,7 C0.44771525,7 6.76353751e-17,6.55228475 0,6 C-6.76353751e-17,5.44771525 0.44771525,5 1,5 L5,5 L5,1 C5,0.44771525 5.44771525,1.01453063e-16 6,0 Z"
                                id="Combined-Shape"
                            ></path>
                        </g>
                    </g>
                </g>
            </svg>
        </span>
    </div>
</template>

<script>
import { debounce } from '../scripts/helpers'

export default {
    name: 'Spinner',
    components: {
        // SpinnerPlus,
        // SpinnerMinus,
    },
    data: function () {
        return {
            numericValue: this.value,
            isPropChange: false,
        }
    },
    props: {
        value: {
            default: 1,
            type: Number,
        },
        min: {
            default: 0,
            type: Number,
        },
        step: {
            default: 1,
            type: Number,
        },
        integerOnly: {
            default: true,
            type: Boolean,
        },
        disabled: {
            default: false,
            type: Boolean,
        },
        large: {
            default: false,
            type: Boolean,
        },
        debounceTime: {
            default: 500,
            type: Number,
        },
    },
    computed: {
        showDelete() {
            if (
                this.min === this.numericValue ||
                this.min > this.numericValue
            ) {
                return true
            } else {
                return false
            }
        },
    },
    methods: {
        increaseNumber() {
            this.isPropChange = false
            if (!this.disabled) {
                this.numericValue += this.step
            }
        },

        decreaseNumber() {
            this.isPropChange = false

            if (this.numericValue === 0) {
                return
            }

            if (!this.disabled) {
                this.numericValue -= this.step
            }
        },

        isInteger(evt) {
            evt = evt ? evt : window.event
            let key = evt.keyCode || evt.which
            key = String.fromCharCode(key)
            const regex = /[0-9]/
            if (!regex.test(key)) {
                evt.returnValue = false
                if (evt.preventDefault) evt.preventDefault()
            }
        },

        isNumber(evt) {
            evt = evt ? evt : window.event
            var charCode = evt.which ? evt.which : evt.keyCode
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault()
            } else {
                return true
            }
        },

        validateInput(evt) {
            if (this.integerOnly === true) {
                this.isInteger(evt)
            } else {
                this.isNumber(evt)
            }
        },

        inputValue(evt) {
            this.isPropChange = false
            let val = evt.target.value ? parseInt(evt.target.value) : this.min

            if (val <= this.min) {
                this.numericValue = parseInt(this.min)
            }

            if (val >= this.max) {
                this.numericValue = parseInt(this.max)
            }

            this.numericValue = val
        },
        inputChanged: debounce((val, vm) => {
            vm.$emit('input', val)
        }, 500),
    },
    watch: {
        value: function (val, oldVal) {
            this.isPropChange = true
            this.numericValue = val
        },
        numericValue: function (val, oldVal) {
            if (this.isPropChange) {
                this.isPropChange = false
                return
            }

            this.inputChanged(val, this)
        },
    },
}
</script>

<style lang="scss">
@import '../../scss/abstracts/variables.scss';

.c-spinner {
    $root: &;

    display: flex;

    textarea,
    select,
    input,
    button {
        outline: none;
    }

    &__button {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 38px;
        width: 35px;
        border: 1px solid $c-medium-grey;
        font-size: 28px;
        user-select: none;
        transition: all $t-hover;

        &--down {
            border-radius: 50% 0 0 50%;
        }

        &--up {
            border-radius: 0 50% 50% 0;
        }

        svg {
            pointer-events: none;
            touch-action: none;
            width: 12px;
            height: auto;

            rect,
            path {
                opacity: 1;
                fill: #666666;
                transition: all $t-hover;
            }
        }

        &:hover {
            cursor: pointer;
            background: $c-black;
            svg {
                rect,
                path {
                    fill: $c-white;
                }
            }
        }
        &::selection {
            color: inherit;
            background: none;
        }
    }

    &__input {
        margin: 0;
        max-width: 68px;
        background: transparent;
        border: none;
        font-family: $font-heading;
        font-size: 17px;
        letter-spacing: -0.13px;
        line-height: 18px;
        text-align: center;
        border-top: 1px solid $c-medium-grey;
        border-bottom: 1px solid $c-medium-grey;
    }

    &--disabled {
        #{$root}__button {
            &:hover {
                cursor: default;
            }
        }
    }

    &--large {
        #{$root}__button {
            width: 50px;
            height: 52px;
        }

        #{$root}__input {
            max-width: 72px;
        }
    }
}
</style>
